import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common components
import CustomAvatar from './../../../common/Avatar/Avatar';
import Breadcrumb from './../../../common/Breadcrumb/Breadcrumb';

const ModuleDetails = ({ moduleDetails, links, questionsLength }) => {
	return (
		<div className='ModuleDetails detailed-view'>
            <div className="Module-image">
				{
					moduleDetails.image_uploaded === 'Y' ? 
					<img src='./assets/images/jpeg/leadingsafeagile_bg2.jpg' /> : <CustomAvatar name={moduleDetails.name} />
				}
            </div>
			<div className="details">
				<div className="row detailed-card">
					<div className="col-8 card-heading">					
						<div className="heading">
							<div className="title">{moduleDetails.name}</div>
							<div className="desc">{moduleDetails.description}</div>
						</div>
					</div>
					<div className="col bread-crumb">
						<Breadcrumb links={links} />
					</div>
				</div>
				<div className="row card-details">
					{/*<div className="col">
						<div className="title">created by</div>
						<div className="value">Jayaprakash</div>
					</div>*/}
					<div className="col">
						<div className="title">created date</div>
						<div className="value">{moment(moduleDetails.created_date).format('DD MMM YYYY')}</div>
					</div>
					{questionsLength > 0 && (
						<div className="col">
							<div className="title"># of questions</div>
							<div className="value">{questionsLength}</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

ModuleDetails.propTypes = {
	moduleDetails: PropTypes.instanceOf(Object),
	links: PropTypes.instanceOf(Array),
	questionsLength: PropTypes.number
};

ModuleDetails.defaultProps = {
	moduleDetails: {},
	links: [],
	questionsLength: 0
};

export default ModuleDetails;



// WEBPACK FOOTER //
// ./components/ModuleQuestion/ModuleDetails/ModuleDetails.js